import { Pipe, PipeTransform } from '@angular/core';

import { CustomTranslationsService } from '../translations';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateRoomHeatUpSpeed',
})
export class TranslateRoomHeatUpSpeedPipe implements PipeTransform {
  constructor(
    private customTranslationsService: CustomTranslationsService,
    private translateService: TranslateService
  ) {}

  transform(value: string): string {
    if (value && this.customTranslationsService.HEAT_UP_SPEED_TYPES[value]) {
      return this.translateService.instant(
        this.customTranslationsService.HEAT_UP_SPEED_TYPES[value] ?? value
      );
    }

    return value;
  }
}
